/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Code} from "./code.zod";
import {Language} from "./language.zod";
import {OfferTemplateState} from "./offerTemplateState.zod";

export const listOfferTemplatesParamsSortKeyDefault = `name`;
export const ListOfferTemplatesParams = zod.object({
  sortKey: zod.enum(["name"]).default(listOfferTemplatesParamsSortKeyDefault),
  q: zod.string().optional(),
  state: OfferTemplateState.optional(),
  language: Language.optional(),
  currencyCode: Code.optional(),
});

export type ListOfferTemplatesParams = zod.input<typeof ListOfferTemplatesParams>;
export type ListOfferTemplatesParamsOutput = zod.output<typeof ListOfferTemplatesParams>;
